import type { Room } from '@hollowveil/shared';

export const roomAncientRuins: Room = {
      id: 'room_ancient_ruins',
      name: "Les Ruines Oubliées",
      description: "D'anciennes ruines surplombant un gouffre. Des ponts spectraux permettent de traverser.",
      size: [26, 12, 26],
      floorStyle: 'ruins',
      ambiance: {
        realWorld: {
          backgroundColor: '#e0f7fa',
          ambientLightColor: '#80deea',
          ambientLightIntensity: 0.7,
        },
        spectralWorld: {
          backgroundColor: '#1a2a3a',
          ambientLightColor: '#4a7a9a',
          ambientLightIntensity: 0.4,
        },
      },
      objects: [
        // Trees in this room
        {
          id: 'obj_ruins_tree_1',
          name: 'Arbre des Ruines',
          type: 'static',
          modelId: 'tree',
          position: [2, 0, 2],
          rotation: [0, 0.5, 0],
          scale: [1.3, 1.5, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_tree_2',
          name: 'Vieil Arbre',
          type: 'static',
          modelId: 'tree',
          position: [12, 0, 12],
          rotation: [0, 2.1, 0],
          scale: [1.5, 1.8, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_tree_3',
          name: 'Arbre Tordu',
          type: 'static',
          modelId: 'tree',
          position: [1, 0, 10],
          rotation: [0.1, 1.2, 0],
          scale: [1, 1.2, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Ruins and pillars
        {
          id: 'obj_ruins_pillar_1',
          name: 'Pilier Brisé',
          type: 'static',
          modelId: 'pillar',
          position: [3, 0, 3],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 3 },
        },
        {
          id: 'obj_ruins_pillar_2',
          name: 'Pilier Ancien',
          type: 'static',
          modelId: 'pillar',
          position: [11, 0, 3],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 4 },
        },
        // Rocks scattered
        {
          id: 'obj_ruins_rocks_1',
          name: 'Débris',
          type: 'static',
          modelId: 'rocks',
          position: [4, 0, 1],
          rotation: [0, 0.6, 0],
          scale: [1.2, 1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_rock_big',
          name: 'Grosse Pierre',
          type: 'static',
          modelId: 'rock',
          position: [10, 0, 1],
          rotation: [0, 1.3, 0],
          scale: [1.5, 1.3, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Bushes
        {
          id: 'obj_ruins_bush',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [13, 0, 8],
          rotation: [0, 0, 0],
          scale: [1.1, 1, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Grande Muraille - visible only in real world, blocks passage
        // Forces player to switch to spectral world to pass through
        // Spans the entire map height (26 units)
        {
          id: 'obj_barrier_1',
          name: 'Grande Muraille',
          type: 'static',
          modelId: 'wall',
          position: [8, 0, 6.5],
          rotation: [0, 0, 0],
          scale: [0.8, 4, 13],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
        },
        {
          id: 'obj_barrier_2',
          name: 'Grande Muraille',
          type: 'static',
          modelId: 'wall',
          position: [8, 0, 19.5],
          rotation: [0, 0, 0],
          scale: [0.8, 4, 13],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
        },
        // Decorative pillars along the barrier
        {
          id: 'obj_barrier_pillar_1',
          name: 'Pilier de la Muraille',
          type: 'static',
          modelId: 'pillar',
          position: [8, 0, 0],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: { height: 5 },
        },
        {
          id: 'obj_barrier_pillar_2',
          name: 'Pilier de la Muraille',
          type: 'static',
          modelId: 'pillar',
          position: [8, 0, 13],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: { height: 5 },
        },
        {
          id: 'obj_barrier_pillar_3',
          name: 'Pilier de la Muraille',
          type: 'static',
          modelId: 'pillar',
          position: [8, 0, 26],
          rotation: [0, 0, 0],
          scale: [1.5, 1.5, 1.5],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: { height: 5 },
        },
        // Holes/pits in the floor - visual indicators
        {
          id: 'obj_pit_1',
          name: 'Gouffre',
          type: 'static',
          modelId: 'hole',
          position: [7, 0, 5],
          rotation: [0, 0, 0],
          scale: [2, 1, 3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_pit_2',
          name: 'Gouffre',
          type: 'static',
          modelId: 'hole',
          position: [7, 0, 9],
          rotation: [0, 0.5, 0],
          scale: [2.5, 1, 2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral bridges - only visible/solid in spectral world
        {
          id: 'obj_bridge_1',
          name: 'Pont Spectral',
          type: 'static',
          modelId: 'spectral_bridge',
          position: [7, 0, 5],
          rotation: [0, 0, 0],
          scale: [1.2, 1, 1.8],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_bridge_2',
          name: 'Pont Spectral',
          type: 'static',
          modelId: 'spectral_bridge',
          position: [7, 0, 9],
          rotation: [0, Math.PI / 4, 0],
          scale: [1.5, 1, 1.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Zone trigger - confirms player crossed the barrier via spectral world
        // Positioned on the other side of the barrier (x > 5)
        {
          id: 'obj_bridge_end',
          name: 'Zone de Passage',
          type: 'trigger',
          modelId: 'block',
          position: [8, 0, 7],
          rotation: [0, 0, 0],
          scale: [3, 0.05, 3],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: { variant: 'highlight' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'Tu as traversé la barrière en passant par le monde spectral !',
              },
            },
          ],
        },
        // The Sage NPC - with riddle system
        {
          id: 'obj_sage',
          name: 'Le Sage',
          type: 'interactive',
          modelId: 'sage',
          position: [12, 0, 7],
          rotation: [0, -Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'showRiddle',
              params: {
                riddle: {
                  id: 'riddle_sage_spectral',
                  npcId: 'obj_sage',
                  npcName: 'Le Sage des Ruines',
                  question: 'Voyageur, écoute mon énigme...\n\nJe suis visible dans l\'ombre mais invisible à la lumière.\nJe révèle ce qui est caché aux yeux des mortels.\nJe suis un reflet du monde que tu connais, mais différent.\n\nQui suis-je ?',
                  hint: 'Pense à ce que tu as découvert dans ton voyage entre les deux mondes...',
                  type: 'multiple_choice',
                  choices: [
                    { id: 'a', text: 'La lune', isCorrect: false },
                    { id: 'b', text: 'Le monde spectral', isCorrect: true },
                    { id: 'c', text: 'Un fantôme', isCorrect: false },
                    { id: 'd', text: 'L\'obscurité', isCorrect: false },
                  ],
                  correctResponse: '"Exactement, jeune voyageur ! Le monde spectral révèle ce que la lumière cache. Tu as prouvé ta sagesse."',
                  incorrectResponse: '"Hmm, ce n\'est pas la réponse que j\'attendais. Réfléchis encore..."',
                  canRetry: true,
                  onCorrect: [
                    {
                      type: 'addToInventory',
                      params: {
                        itemId: 'sage_wisdom',
                        itemName: 'Sagesse du Sage',
                        itemDescription: 'Un fragment de connaissance ancienne accordé par le Sage.',
                        itemIcon: 'scroll',
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
        // === BLOCKING DOOR SYSTEM ===
        // Wall blocking passage to relic area (top side)
        {
          id: 'obj_relic_wall_top',
          name: 'Mur Ancien',
          type: 'static',
          modelId: 'wall',
          position: [9, 0, 2],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Wall blocking passage to relic area (bottom side)
        {
          id: 'obj_relic_wall_bottom',
          name: 'Mur Ancien',
          type: 'static',
          modelId: 'wall',
          position: [9, 0, 12],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Large door requiring forest blessing - blocks the middle passage
        {
          id: 'obj_relic_door',
          name: 'Porte de la Nature',
          type: 'interactive',
          modelId: 'animated_door',
          position: [9, 0, 7],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'openDoorWithItem',
              params: {
                doorId: 'obj_relic_door',
                requiredItemId: 'forest_blessing',
              },
            },
          ],
        },
        // Ancient relic - final objective (visible in real world, behind the barrier)
        {
          id: 'obj_relic',
          name: 'Relique Ancienne',
          type: 'interactive',
          modelId: 'crystal',
          position: [10, 0.5, 10],
          rotation: [0, 0, 0],
          scale: [1.2, 1.5, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'ancient_relic',
                itemName: 'Relique Ancienne',
                itemDescription: 'Un artefact ancien pulsant d\'énergie mystique.',
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as récupéré la Relique Ancienne ! Elle brille d\'une lumière intense.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_relic',
              },
            },
          ],
        },
        // Flowers and plants for atmosphere
        {
          id: 'obj_ruins_flower',
          name: 'Fleur Bleue',
          type: 'static',
          modelId: 'flower',
          position: [5, 0, 2],
          rotation: [0, 0.8, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_plant',
          name: 'Plante Grimpante',
          type: 'static',
          modelId: 'plant',
          position: [9, 0, 2],
          rotation: [0, 1.5, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral orbs for atmosphere
        {
          id: 'obj_ruins_orb_1',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [6, 1.5, 7],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_ruins_orb_2',
          name: 'Orbe Flottant',
          type: 'static',
          modelId: 'orb',
          position: [8, 2, 8],
          rotation: [0, 0, 0],
          scale: [0.5, 0.5, 0.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // === Additional decorations for enlarged ruins (26x26) ===
        // More trees on the far side
        {
          id: 'obj_ruins_tree_4',
          name: 'Arbre',
          type: 'static',
          modelId: 'tree',
          position: [22, 0, 4],
          rotation: [0, 1.8, 0],
          scale: [1.2, 1.4, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_tree_5',
          name: 'Arbre Ancien',
          type: 'static',
          modelId: 'ancient_tree',
          position: [18, 0, 20],
          rotation: [0, 0.6, 0],
          scale: [1.5, 1.7, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_tree_6',
          name: 'Arbre',
          type: 'static',
          modelId: 'tree',
          position: [4, 0, 22],
          rotation: [0, 2.3, 0],
          scale: [1.1, 1.3, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_tree_7',
          name: 'Petit Arbre',
          type: 'static',
          modelId: 'tree',
          position: [24, 0, 16],
          rotation: [0, 3.5, 0],
          scale: [0.8, 0.9, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More pillars (broken columns)
        {
          id: 'obj_ruins_pillar_3',
          name: 'Colonne Brisée',
          type: 'static',
          modelId: 'column',
          position: [20, 0, 8],
          rotation: [0, 0.4, 0],
          scale: [1, 0.6, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_pillar_4',
          name: 'Pilier',
          type: 'static',
          modelId: 'pillar',
          position: [16, 0, 22],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 3 },
        },
        {
          id: 'obj_ruins_column_1',
          name: 'Colonne',
          type: 'static',
          modelId: 'column',
          position: [14, 0, 18],
          rotation: [0, 0, 0],
          scale: [1.1, 1.2, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Debris and rubble
        {
          id: 'obj_ruins_debris_1',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [17, 0, 5],
          rotation: [0, 1.2, 0],
          scale: [1.5, 1, 1.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_debris_2',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [22, 0, 12],
          rotation: [0, 2.8, 0],
          scale: [1.2, 1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_debris_3',
          name: 'Débris',
          type: 'static',
          modelId: 'debris',
          position: [6, 0, 20],
          rotation: [0, 0.5, 0],
          scale: [1.3, 1, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More rocks
        {
          id: 'obj_ruins_rock_2',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [24, 0, 22],
          rotation: [0, 1.5, 0],
          scale: [1.3, 1.1, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_rock_3',
          name: 'Pierre',
          type: 'static',
          modelId: 'rock',
          position: [2, 0, 18],
          rotation: [0, 2.2, 0],
          scale: [0.8, 0.7, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_rocks_2',
          name: 'Cailloux',
          type: 'static',
          modelId: 'rocks',
          position: [19, 0, 14],
          rotation: [0, 0.8, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Statues
        {
          id: 'obj_ruins_statue_1',
          name: 'Statue Ancienne',
          type: 'static',
          modelId: 'statue',
          position: [21, 0, 2],
          rotation: [0, -Math.PI / 3, 0],
          scale: [1, 1.2, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_statue_2',
          name: 'Statue Brisée',
          type: 'static',
          modelId: 'statue',
          position: [10, 0, 24],
          rotation: [0.2, Math.PI / 4, 0],
          scale: [0.8, 0.6, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Graves
        {
          id: 'obj_ruins_grave_1',
          name: 'Tombe Ancienne',
          type: 'static',
          modelId: 'grave',
          position: [23, 0, 18],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_grave_2',
          name: 'Tombe',
          type: 'static',
          modelId: 'grave',
          position: [24, 0, 19.5],
          rotation: [0, 0.2, 0],
          scale: [0.9, 0.9, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // === SECRET HIDDEN ITEM - NOT IN QUEST ===
        // Fragment d'Ombre caché près d'une tombe - visible uniquement dans le monde spectral
        // Nécessaire dans le niveau 4 pour le Gardien des Secrets
        {
          id: 'obj_shadow_fragment',
          name: 'Fragment d\'Ombre',
          type: 'interactive',
          modelId: 'gem',
          position: [24, 0.3, 18.5],
          rotation: [0, 0, 0],
          scale: [0.6, 0.6, 0.6],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'shadow_fragment',
                itemName: 'Fragment d\'Ombre',
                itemDescription: 'Un éclat de ténèbres pures. On dirait qu\'il appelle quelqu\'un...',
                itemIcon: 'gem',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu trouves un Fragment d\'Ombre ! Il semble... attendre quelque chose.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_shadow_fragment',
              },
            },
          ],
        },
        // Altar
        {
          id: 'obj_ruins_altar',
          name: 'Autel Abandonné',
          type: 'static',
          modelId: 'altar',
          position: [15, 0, 24],
          rotation: [0, Math.PI, 0],
          scale: [1.2, 1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Vines on walls
        {
          id: 'obj_ruins_vines_1',
          name: 'Lierre',
          type: 'static',
          modelId: 'vines',
          position: [0.5, 1.5, 16],
          rotation: [0, 0, 0],
          scale: [1, 2.5, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_vines_2',
          name: 'Lierre',
          type: 'static',
          modelId: 'vines',
          position: [25.5, 1, 10],
          rotation: [0, Math.PI, 0],
          scale: [1.2, 2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Mushrooms
        {
          id: 'obj_ruins_mushroom_1',
          name: 'Champignons',
          type: 'static',
          modelId: 'mushroom',
          position: [3, 0, 15],
          rotation: [0, 0.5, 0],
          scale: [0.8, 0.8, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_mushroom_2',
          name: 'Champignons Lumineux',
          type: 'static',
          modelId: 'mushroom',
          position: [20, 0, 24],
          rotation: [0, 1.8, 0],
          scale: [1, 1.1, 1],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Lanterns and torches
        {
          id: 'obj_ruins_torch_1',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [16, 0, 4],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_torch_2',
          name: 'Torchère',
          type: 'static',
          modelId: 'torch_stand',
          position: [4, 0, 24],
          rotation: [0, 0, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_lantern_1',
          name: 'Lanterne',
          type: 'static',
          modelId: 'lantern',
          position: [12, 0, 20],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More bushes
        {
          id: 'obj_ruins_bush_2',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [19, 0, 10],
          rotation: [0, 0.9, 0],
          scale: [1, 0.9, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_bush_3',
          name: 'Buisson',
          type: 'static',
          modelId: 'bush',
          position: [6, 0, 24],
          rotation: [0, 2.2, 0],
          scale: [1.2, 1.1, 1.2],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More flowers
        {
          id: 'obj_ruins_flower_2',
          name: 'Fleurs',
          type: 'static',
          modelId: 'flower',
          position: [22, 0, 8],
          rotation: [0, 1.2, 0],
          scale: [0.9, 0.9, 0.9],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_ruins_flower_3',
          name: 'Fleurs',
          type: 'static',
          modelId: 'flower',
          position: [8, 0, 22],
          rotation: [0, 2.5, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral orbs
        {
          id: 'obj_ruins_orb_3',
          name: 'Orbe',
          type: 'static',
          modelId: 'orb',
          position: [18, 2.2, 16],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_ruins_orb_4',
          name: 'Orbe',
          type: 'static',
          modelId: 'orb',
          position: [4, 1.8, 20],
          rotation: [0, 0, 0],
          scale: [0.35, 0.35, 0.35],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
      ],
      puzzles: [
        {
          id: 'puzzle_ruins',
          name: "L'Énigme du Sage",
          type: 'worldBridge',
          state: 'active',
          description: "Traverse les ruines et résous l'énigme pour obtenir la relique.",
          hint: 'La barrière n\'existe pas dans le monde spectral. Change de monde pour passer...',
          linkedObjectIds: ['obj_bridge_end', 'obj_sage', 'obj_relic'],
          solution: {
            type: 'sequence',
            expected: ['obj_bridge_end', 'obj_sage', 'obj_relic'],
          },
          onSolve: [
            {
              type: 'showMessage',
              params: {
                message: 'Le pouvoir de la relique est maintenant tien !',
              },
            },
          ],
        },
      ],
      connections: [
        {
          targetRoomId: 'room_forest_garden',
          position: [0, 0, 6],
          direction: 'west',
          locked: false,
        },
        {
          targetRoomId: 'room_shadow_temple',
          position: [14, 0, 7],
          direction: 'east',
          locked: false,
        },
      ],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'desert',
      biome: 'desert',
      weather: 'sandstorm',
      weatherIntensity: 0.4,
      npcs: [
        {
          id: 'npc_camel_1',
          type: 'camel',
          name: 'Chameau Patient',
          position: [6, 0, 18],
          scale: 3.5,
          idleAnimation: 'stand',
          petAnimation: 'nuzzle',
          petRadius: 4,
          petCooldown: 3500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_camel_2',
          type: 'camel',
          name: 'Chameau Sage',
          position: [20, 0, 20],
          scale: 3,
          idleAnimation: 'stand',
          petAnimation: 'nuzzle',
          petRadius: 4,
          petCooldown: 3500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_fennec_1',
          type: 'fennec',
          name: 'Fennec Curieux',
          position: [18, 0, 6],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'happy',
          petRadius: 2.5,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_snake_1',
          type: 'snake',
          name: 'Serpent du Désert',
          position: [10, 0, 10],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 3000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_lizard_1',
          type: 'lizard',
          name: 'Lézard du Désert',
          position: [14, 0, 16],
          scale: 3,
          idleAnimation: 'sit',
          petAnimation: 'happy',
          petRadius: 2,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_scorpion_1',
          type: 'scorpion',
          name: 'Scorpion Spectral',
          position: [22, 0, 12],
          scale: 3,
          idleAnimation: 'stand',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 4000,
          isPettable: true,
          visibleInWorld: 'spectral',
        },
      ],
};
